/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChiusuraExtraCreateDTO
 */
export interface ChiusuraExtraCreateDTO {
    /**
     * 
     * @type {number}
     * @memberof ChiusuraExtraCreateDTO
     */
    sequenza?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ChiusuraExtraCreateDTO
     */
    descrizione?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ChiusuraExtraCreateDTO
     */
    importo?: number;
}

/**
 * Check if a given object implements the ChiusuraExtraCreateDTO interface.
 */
export function instanceOfChiusuraExtraCreateDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ChiusuraExtraCreateDTOFromJSON(json: any): ChiusuraExtraCreateDTO {
    return ChiusuraExtraCreateDTOFromJSONTyped(json, false);
}

export function ChiusuraExtraCreateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChiusuraExtraCreateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sequenza': !exists(json, 'sequenza') ? undefined : json['sequenza'],
        'descrizione': !exists(json, 'descrizione') ? undefined : json['descrizione'],
        'importo': !exists(json, 'importo') ? undefined : json['importo'],
    };
}

export function ChiusuraExtraCreateDTOToJSON(value?: ChiusuraExtraCreateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sequenza': value.sequenza,
        'descrizione': value.descrizione,
        'importo': value.importo,
    };
}

